import { Dialog, DialogContent } from "@/components/ui/dialog";
import { AddCostsDialogForm } from "./AddCostsDialogForm";
import { CostFormData } from "@/types/costs";

interface AddCostsDialogProps {
  isOpen: boolean;
  isSubmitting: boolean;
  onSubmit: (data: CostFormData) => void;
  onClose: () => void;
}
export const AddCostsDialog = ({
  isOpen,
  isSubmitting,
  onSubmit,
  onClose,
}: AddCostsDialogProps) => (
  <Dialog open={isOpen} onOpenChange={onClose}>
    <DialogContent className="w-4/5 max-w-xl">
      <AddCostsDialogForm onSubmit={onSubmit} isSubmitting={isSubmitting} />
    </DialogContent>
  </Dialog>
);
